module.exports = __webpack_public_path__ + "img/doctor.6bd8c515.png";